import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './menu-paje.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { getGrupListDb, getMenuGrupDb, removeMenuBd, addMenuBd } from '../../firebase';
import { addMenu, removeMenuRedux } from '../../store/slices/showMenuSlice';
import LoaderElementSticky from '../../components/LoaderElementSticky/LoaderElementSticky';
import { addMenuEditRedux } from '../../store/slices/menuSlice';
import HeaderMenu from '../../components/HeaderMenu/HeaderMenu';
import { getGroupName } from '../../helperProject';
import GetHistoryMenu from '../../components/GetHistoryMenu/GetHistoryMenu';
import { pathHome } from '../../path';
import NutritionalTableDay from '../../components/NutritionalTableDay/NutritionalTableDay';

export default function MenuPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { group_id } = useParams();

  // Лоадер при завантаженні меню
  const [loader, setLoader] = useState(false);

  const [modal, setModal] = useState({ show: false, items: [] });
  const [modalCloneMenu, setModalCloneMenu] = useState({
    show: false,
    loading: false,
    items: [],
    selectedGroup: {},
    numberDay: 0,
  });

  const indexRenderMenuDey = useSelector((state) => state.showMenu.indexRenderMenuDey);
  const showMenu = useSelector((state) => state.showMenu.menu);
  const groups = useSelector((state) => state.groups.groupsList);

  useEffect(() => {
    setLoader(true);
    const getMenu = async () => {
      const menu = await getMenuGrupDb('menu', group_id);

      if (menu === 'error') {
        alert('Помилка при отримані данних!!!');
        dispatch(addMenu({}));
      } else {
        dispatch(addMenu(menu));
      }
      // setTimeout(() => {
      setLoader(false);
      // }, 5000);
    };

    getMenu();

    return () => {
      setLoader(false);
    };
  }, []);

  const selectedGroup = (group) => {
    setModalCloneMenu({ ...modalCloneMenu, selectedGroup: group });
  };

  const showCloneMenu = async (menuDay, setModalCloneMenu) => {
    // console.log(modalCloneMenu);

    // if(modalCloneMenu )
    setModalCloneMenu({ ...modalCloneMenu, show: true, loading: true });

    const fetchData = async () => {
      const groupsListArray = await getGrupListDb();
      setModalCloneMenu({
        ...modalCloneMenu,
        loading: false,
        show: true,
        items: groupsListArray,
        numberDay: menuDay.dayNumber,
      });
    };
    fetchData();
  };

  const addCloneMenu = async (objectModal, menu) => {
    const group_id = objectModal.selectedGroup.group_id;
    const dayNumber = objectModal.numberDay;
    const groupName = getGroupName(groups, group_id);

    if (!Object.keys(objectModal.selectedGroup).length) {
      alert('Виберіть групу куди копіювати.');
      return;
    }
    setModalCloneMenu({ ...modalCloneMenu, show: true, loading: true });

    const isAddMenu = await addMenuBd(
      group_id,
      {
        ...menu,
        dayNumber: dayNumber,
        id: 'menu_day_' + new Date().getTime(),
      },
      groupName,
    );

    if (isAddMenu) {
      setModalCloneMenu({
        show: false,
        loading: false,
        items: [],
        selectedGroup: {},
        numberDay: 0,
      });
      return;
    }
    setModalCloneMenu({ ...modalCloneMenu, show: true, loading: false });
    // console.log(objectModal);
    // console.log(menu);
    // console.log({ ...menu, id: 'menu_day_' + new Date().getTime() });
  };

  const getKeyRenderDay = (transition, indexRenderMenuDey, showMenu) => {
    const menyKeys = Object.keys(showMenu);

    for (let index = 0; index < menyKeys.length; index++) {
      const itemKey = menyKeys[index];

      if (itemKey === indexRenderMenuDey) {
        if (transition === 'back') {
          return menyKeys[index - 1];
        }
        if (transition === 'next') {
          return menyKeys[index + 1];
        }
      }
    }

    return false;
  };
  // Видаляє меню конкретного дня
  const removeMenu = async (group_id, indexRenderMenuDey, menuDay) => {
    let isRemove = window.confirm('Видалити меню цього дня?');
    setLoader(true);

    if (isRemove) {
      await removeMenuBd(group_id, indexRenderMenuDey, menuDay);
      if (getKeyRenderDay('back', indexRenderMenuDey, showMenu)) {
        dispatch(
          removeMenuRedux({
            indexRenderMenuDey,
            newIndexRenderMenuDey: getKeyRenderDay('back', indexRenderMenuDey, showMenu),
          }),
        );
        setLoader(false);

        return;
      }
      if (getKeyRenderDay('next', indexRenderMenuDey, showMenu)) {
        dispatch(
          removeMenuRedux({
            indexRenderMenuDey,
            newIndexRenderMenuDey: getKeyRenderDay('next', indexRenderMenuDey, showMenu),
          }),
        );
        setLoader(false);

        return;
      }

      dispatch(
        removeMenuRedux({
          indexRenderMenuDey,
          newIndexRenderMenuDey: false,
        }),
      );
    }
    setLoader(false);
  };

  //Редагує день
  const editMenuDay = (group_id, menuDay) => {
    dispatch(addMenuEditRedux(menuDay));
    navigate(`/${pathHome}/addMenu/` + group_id);
  };

  const renderIngredients = (ingredients) => {
    return ingredients.map((item) => {
      return item.ingredientsItems.length > 1 ? (
        <li key={item.id}>
          <span
            className={styles.ingredients_li_modal}
            onClick={() => setModal({ show: true, items: item.ingredientsItems })}>
            {item.ingredientsItems[item.itemActive].text}
          </span>
        </li>
      ) : item.titleIngredients ? (
        <li key={item.id} className={styles.ingredient_li + ' ' + styles.ingredient_li_title}>
          {item.ingredientsItems[item.itemActive].text}
        </li>
      ) : (
        <li key={item.id} className={styles.ingredient_li}>
          {item.ingredientsItems[item.itemActive].text}
        </li>
      );
    });
  };

  const renderMealContent = (mealMenuText) => {
    return mealMenuText.map((meal) => {
      return (
        <div key={meal.id} className={styles.meal_item_wrapper}>
          {meal.title ? <div className={styles.meal_title}>{meal.title}</div> : ''}
          {meal.ingredients.length ? <ul>{renderIngredients(meal.ingredients)}</ul> : ''}
          {meal.text ? <div className={styles.meal_text}>{meal.text}</div> : ''}
          {meal.videoUrl ? <div>Посилання на відео: {meal.videoUrl} </div> : ''}
        </div>
      );
    });
  };

  const renderMeal = (meal) => {
    return (
      <div
        className={
          meal.twoServings
            ? styles.meal_wrapper + ' ' + styles.meal_wrapper_twoServings
            : styles.meal_wrapper
        }>
        <div className={styles.meal_header}>{meal.title}</div>
        <div className={styles.meal_content_wrapper}>
          {meal && meal.menuText.length ? (
            renderMealContent(meal.menuText)
          ) : meal.repeatMenu ? (
            <div className={'fw_600'}>{meal.repeatMenuTitle}</div>
          ) : (
            <div>Пусто:)</div>
          )}
        </div>
      </div>
    );
  };
  const renderTraining = (trainingObject) => {
    if (trainingObject) {
      return trainingObject.title;
    } else {
      return 'Без тренування';
    }
  };

  const renderMenuDay = (menuDay) => {
    return (
      <div className={styles.menu_wrapper}>
        <GetHistoryMenu menuDay={menuDay} />
        <NutritionalTableDay menuDayProps={menuDay} />

        <button
          className={
            menuDay.training
              ? styles.training_btn + ' ' + styles.training_btn_active
              : styles.training_btn
          }>
          {renderTraining(menuDay.training)}
        </button>

        {renderMeal(menuDay.breakfast)}
        {renderMeal(menuDay.snack)}
        {renderMeal(menuDay.dinner)}
        {renderMeal(menuDay.supper)}
        <div className={styles.menu_btn_wrapper}>
          <button
            className={styles.menu_btn + ' ' + styles.delet_menu_btn}
            onClick={() => removeMenu(group_id, indexRenderMenuDey, menuDay)}>
            Видалити
          </button>
          <button
            className={styles.menu_btn + ' ' + styles.clone_menu_btn}
            onClick={() => showCloneMenu(menuDay, setModalCloneMenu)}>
            Клонувати
          </button>
          <button
            className={styles.menu_btn + ' ' + styles.edit_menu_btn}
            onClick={() => editMenuDay(group_id, menuDay)}>
            Редагувати
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* -------------- Header ------------------------ */}

      <HeaderMenu showMenu={showMenu} />

      {/* -------------- /Header ------------------------ */}
      {/* -------------- Content ------------------------ */}
      {loader ? (
        <div className={styles.loader_wrapper}>
          <LoaderElementSticky />
        </div>
      ) : showMenu && Object.keys(showMenu).length && showMenu[indexRenderMenuDey] ? (
        renderMenuDay(showMenu[indexRenderMenuDey])
      ) : (
        <div className={styles.content_empty}>Пусто:)</div>
      )}
      {/* --------------- Modal ------------------------ */}
      {modal.show && (
        <div className={styles.modal_wrapper}>
          <div className={styles.modal_content_wrapper}>
            <button
              className={styles.modal_close_btn}
              onClick={() => setModal({ show: false, items: [] })}>
              Закрити
            </button>
            <ul>
              {modal.items.map((item) => {
                return (
                  <li className={styles.modal_li} key={item.id}>
                    {item.text}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
      {modalCloneMenu.show && (
        <div className={styles.modal_wrapper}>
          <div className={styles.modal_content_wrapper + ' ' + styles.modal_clone_content_wrapper}>
            <button
              className={styles.modal_close_btn}
              onClick={() =>
                setModalCloneMenu({
                  show: false,
                  loading: false,
                  items: [],
                  selectedGroup: {},
                  numberDay: 0,
                })
              }>
              Закрити
            </button>
            {modalCloneMenu.loading ? (
              <div className={styles.modal_clone_groups_loading}>Загрузка...</div>
            ) : modalCloneMenu.items.length > 1 ? (
              <>
                <div className={styles.modal_clone_groups_wtapper}>
                  {modalCloneMenu.items.map((item) => {
                    return group_id !== item.group_id ? (
                      <div
                        className={styles.modal_clone_group}
                        key={item.group_id}
                        onClick={() => selectedGroup(item)}>
                        {item.groupName}
                        <div
                          className={
                            modalCloneMenu.selectedGroup.group_id &&
                            modalCloneMenu.selectedGroup.group_id === item.group_id
                              ? styles.modal_clone_group_selected +
                                ' ' +
                                styles.modal_clone_group_selected_active
                              : styles.modal_clone_group_selected
                          }
                        />
                      </div>
                    ) : (
                      ''
                    );
                  })}
                </div>
                <div className={styles.numberDay_wrapper}>
                  <div>День №</div>
                  <input
                    type="number"
                    className={styles.input_NumberDay}
                    placeholder="Цифра..."
                    defaultValue={modalCloneMenu.numberDay}
                    onChange={(e) =>
                      setModalCloneMenu({ ...modalCloneMenu, numberDay: e.target.value })
                    }
                  />
                </div>
                <button
                  className={styles.menu_btn + ' ' + styles.clone_menu_btn}
                  onClick={() => addCloneMenu(modalCloneMenu, showMenu[indexRenderMenuDey])}>
                  Клонувати
                </button>
              </>
            ) : (
              <div>Груп не знайдено.</div>
            )}
          </div>
        </div>
      )}
      {/* --------------- /Modal ------------------------ */}

      {/* -------------- /Content ------------------------ */}
    </>
  );
}
